import { CloseOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import { PdfViewer } from '@medcom/shared-ui/components/PdfViewer/PdfViewer.tsx';
import { Modal } from 'antd';
import type React from 'react';
import type { ReactNode } from 'react';
import { LoadingIndicator } from './LoadingIndicator';

interface Props {
  title: string;
  url: string;
  loading: boolean;
  footer?: ReactNode;
  onClose: () => void;
}

export const PdfPreviewModal: React.FC<Props> = ({ title, url, loading, footer, onClose }) => {
  return (
    <Modal
      className={css`
        top: 16px;
        padding-bottom: 0;
        user-select: none;

        .ant-modal-body {
          height: calc(100vh - 140px);
          padding: 0;
        }
      `}
      title={title}
      destroyOnHidden
      open={!!url || loading}
      width="100%"
      cancelButtonProps={{ hidden: true }}
      okButtonProps={{ icon: <CloseOutlined /> }}
      okText="Schließen"
      onOk={onClose}
      onCancel={onClose}
      footer={footer}
    >
      {loading ? <LoadingIndicator /> : <PdfViewer src={url} />}
    </Modal>
  );
};
